import Image from "next/image";

import { Copyright } from "./Copyright";

const FIT_CLIP_WIDTH = 800;
const FIT_CLIP_HEIGHT = 600;

type ImageData = {
  url: string;
  alt?: string | null;
  title?: string | null;
  copyright?: string | null;
};

export function FitClip(props: { image: ImageData }) {
  const image = props.image;
  const src = `${image.url}?w=${FIT_CLIP_WIDTH}&h=${FIT_CLIP_HEIGHT}&fit=clip&auto=format`;

  return (
    <div className="relative mx-auto max-w-[640px]">
      <Image
        src={src}
        width={FIT_CLIP_WIDTH}
        height={FIT_CLIP_HEIGHT}
        alt={image.alt || image.title || ""}
        className="h-auto w-full"
      />
      <Copyright text={image.copyright} />
    </div>
  );
}
